export const FALLBACK_HANDLERS = {
    WALLET: 'Wallet',
    FREE_PLAY: 'FreePlay'
}